import { mergeByProp } from '@shared/utils';
import getThreadId from '@/lib/threads/getThreadId.js';
import sortThreadsBySidebarTimestamp from '@/lib/threads/sortThreadsBySidebarTimestamp.js';

const upsertSortedThread = (threads = [], thread = null) => {
  const normalizedThreadId = getThreadId(thread);

  if (!normalizedThreadId) {
    return Array.isArray(threads) ? threads : [];
  }

  const nextThread = {
    ...(thread || {}),
    id: normalizedThreadId
  };
  const nextThreads = mergeByProp(
    'id',
    Array.isArray(threads) ? threads : [],
    [nextThread],
    (existingThread, incomingThread) => {
      return {
        ...existingThread,
        ...incomingThread
      };
    },
    { keepPosition: true }
  );

  return sortThreadsBySidebarTimestamp(nextThreads);
};

export default upsertSortedThread;
